module.exports = __webpack_public_path__ + "img/sign-default.89dc5c88.png";